import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Spinner,
} from '@chakra-ui/react';
import { filesApi } from '@texas/api/endpoints/filesApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { PdfPreview } from '@texas/components/shared/files/PdfPreview';
import { ErrorDetails } from '@texas/components/shared/alert/ErrorDetails';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends SharedDisclosureProps {
  fileId: number;
}

export function LayoutViewerModal({ isOpen, onClose, fileId }: Props) {
  const { t } = useTranslation();
  const {
    data: file,
    loading,
    refetch,
    error,
  } = useApiResource(filesApi.getFileLink);

  useEffect(() => {
    if (isOpen) refetch(fileId);
  }, [fileId, isOpen, refetch]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('compositionGroup.version.viewLayout')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {loading && <Spinner />}
          {error && <ErrorDetails error={error} />}
          {file && (
            <PdfPreview
              identifier={file.identifier}
              title={file.originalName}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
